// @flow
import request from 'db-request';
import translate from '@e4/intl/translate.macro';

const logoffLandingPage = `${process.env.REACT_APP_NETBANK_BASE_URL}${translate(
  'logoff.url'
)}`;

export async function logoff(callback = null) {
  window.sessionStorage.removeItem('id');
  window.sessionStorage.removeItem('sessionId');

  try {
    await request.post(
      '/security/auth/api/auth/v1/logout',
      {},
      {
        baseUrl: process.env.REACT_APP_API_MARKET_BASE_URL,
      }
    );
  } catch (ex) {
    // Silence please...
  } finally {
    if (callback) {
      callback();
    }
    document.location.href = logoffLandingPage;
  }
}

export function redirectToLandingPage() {
  document.location.href = logoffLandingPage;
}
